module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r4n8n7n-ef3737ca4987f07264be0088c0e26531.svg";